import styled, { createGlobalStyle } from 'styled-components';

import theme from '../../theme';

export const Global = createGlobalStyle`
    body, html, #___gatsby, #gatsby-focus-wrapper {
        width: 100%;
    }

    body {
        display: flex;
        align-items: center;
        justify-content: center;

        margin: 0;
        padding: 0;

        font-family: sans-serif;
    }
`;

export const Layout = styled.div`
    padding: ${theme.layout.gutter};

    text-align: center;
    background-position: center;
    background-size: cover;

    *::selection {
        background: ${theme.colors.primary};
        color: ${theme.colors.background};
    }
`;
